import React, { FC } from 'react';
import Default from './Default';
import Mobile from './Mobile';
import { IHeaderMenuPropsDefault } from './types';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

const HeaderMenu: FC<IHeaderMenuPropsDefault> = ({ children, ...restOfProps }) => {
  const screen = useBreakpoint();
  const variant = screen.md ? null : 'mobile';

  let Component = Default;

  if (variant === 'mobile') {
    Component = Mobile;
  }

  return <Component {...restOfProps}>{children}</Component>;
};

export default HeaderMenu;
